import { render } from "./BreadcrumbsNavVehicle.vue?vue&type=template&id=148ce40a&scoped=true"
import script from "./BreadcrumbsNavVehicle.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsNavVehicle.vue?vue&type=script&lang=js"

import "./BreadcrumbsNavVehicle.vue?vue&type=style&index=0&id=148ce40a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148ce40a"]])

export default __exports__